/**/
$(document).ready(function () {
    // слайдер Swiper
    const productPreviewImgSlider = new Swiper('.productPreview .productPreviewImgSlider', {
        // Optional parameters
        loop: true,

        // Pagination
        pagination: {
            el: '.productPreview .productPreviewImgSlider .swiper-pagination',
            clickable: true,
        }
    });

    if ($(window).width() > 768) {
        /*переключение слайдов (фото) при наведении и сдвиге мышки назад-вперед*/
        document
            .querySelectorAll('.productPreview .productPreview__imgSliderWrap .swiper-pagination .swiper-pagination-bullet')
            .forEach(el => el.addEventListener('mouseover', (event) => {
                el.click();
            }));
    }


    /*Добавление в избранное*/
    $('.productPreview .productPreview__like').on('click', function () {
        $(this).toggleClass('active');
    });

    /*Кнопка добавления в корзину  в десктопе*/
    /*$('.productPreview .productPreview__btn.productPreview__btn_desktop').on('click', function () {
        $(this).addClass('added-in-cart');
        $(this).html('Перейти в корзину');
    });*/

    /*Кнопка добавления в корзину  в таблетке и мобилке*/
    /*$('.productPreview .productPreview__btn.productPreview__btn_mobile').on('click', function () {
        $(this).addClass('added-in-cart');
    });*/
});
